import { configureStore, combineReducers } from "@reduxjs/toolkit";
// Types
import Reducers from "types/Reducers";
// Reducers
import UiReducer from './ui/uiSlice';
import AuthReducer from './auth/authSlice';
import QuizReducer from './quiz/quizSlice';
import PlayerReducer from './player/playerSlice';
import RoktReducer from './rokt/roktSlice';
import ConsentReducer from './consent/consentSlice';
import PagesReducer from './pages/pagesSlice';
// Middlewares
import errorHandlerMiddleware from "middlewares/errorHandler.middleware";

const rootReducer = combineReducers({
  [Reducers.UI]: UiReducer,
  [Reducers.Auth]: AuthReducer,
  [Reducers.Quiz]: QuizReducer,
  [Reducers.Player]: PlayerReducer,
  [Reducers.Rokt]: RoktReducer,
  [Reducers.Consent]: ConsentReducer,
  [Reducers.Pages]: PagesReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  }).concat(errorHandlerMiddleware)
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
